var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLvector = function SvgLvector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 35,
    fill: "none",
    viewBox: "0 0 47 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#686E74",
    d: "M1 0v40.5a7 7 0 0 0 7 7h50.5"
  })));
};
export default SvgLvector;